import apiService from "service/api";
import { ICreateVaccine } from "types";

//!
export const searchClientsVaccine = (vid: string) => {
  let url = `/vaccine/vaccinations/search/?client_ino=${vid}`;
  const method = "get";
  return apiService(url, method, null, true);
};

export const searchVaccinationsByVid = (vid: string) => {
  const url = `/vaccine/vaccinations/search/${vid}/`;
  return apiService(url, "GET", null, true);
};
// end of new

export const getAllVaccine = (category: string) => {
  const url = `/vaccine/?category=${category}`;
  return apiService(url, "GET", null, true);
};

export const getAllVacination = (
  hfId: number,
  page: number,
  size: number,
  params: {
    client?: string;
    client_ino?: string;
    created_by?: string;
    gender?: string;
    is_complete?: boolean;
    is_cowvaVerified?: boolean;
    location?: number;
    sort?: string[];
    vaccine?: string;
    vid?: string;
  } = {}
) => {
  const queryParams = new URLSearchParams();

  // Add pagination parameters
  queryParams.append("page", page.toString());
  queryParams.append("size", size.toString());

  // Add optional filter parameters
  if (params.client) queryParams.append("client", params.client);
  if (params.client_ino) queryParams.append("client_ino", params.client_ino);
  if (params.created_by) queryParams.append("created_by", params.created_by);
  if (params.gender) queryParams.append("gender", params.gender);

  // Handle boolean values
  if (params.is_complete !== undefined)
    queryParams.append("is_complete", params.is_complete.toString());
  if (params.is_cowvaVerified !== undefined)
    queryParams.append("is_cowvaVerified", params.is_cowvaVerified.toString());

  // Handle numeric location
  if (params.location !== undefined)
    queryParams.append("location", params.location.toString());

  // Handle array of sort values
  if (params.sort && params.sort.length > 0)
    params.sort.forEach((sort) => queryParams.append("sort", sort));

  // Add vaccine filter
  if (params.vaccine) queryParams.append("vaccine", params.vaccine);

  // Add vaccination ID filter
  if (params.vid) queryParams.append("vid", params.vid);

  const url = `/vaccine/${hfId}/vaccinations/?${queryParams.toString()}`;
  return apiService(url, "GET", null, true);
};


export const createVaccination = (
  hfId: number,
  formData: Record<string, any>
) => {
  const url = `/vaccine/${hfId}/vaccinations/`;
  return apiService(url, "POST", formData, true);
};

export const getVaccineCategories = () => {
  const url = `/vaccine/categories/`;
  return apiService(url, "GET", null, true);
};

export const getVaccineBrand = (hfId: number, vaccineId: number) => {
  const url = `/vaccine/${hfId}/brand/?vaccine_id=${vaccineId}`;
  return apiService(url, "GET", null, true);
};

export const getSopAggreement = (hfid: number, vaccineId: number) => {
  const url = `/vaccine/${hfid}/sopagreementbeforeadministration/?vaccine_id=${vaccineId}`;
  return apiService(url, "GET", null, true);
};

export const getSopContraindiction = (hfid: number, vaccineId: number) => {
  const url = `/vaccine/${hfid}/sopagreementcontraindiction/?vaccine_id=${vaccineId}`;
  return apiService(url, "GET", null, true);
};

export const getVaccineByVid = (vid: string, hfId: number) => {
  const url = `/vaccine/${hfId}/vaccinations/${vid}/`;
  return apiService(url, "GET", null, true);
};

export const addShot = (
  hfid: number,
  vid: string,
  formData: Record<string, any>
) => {
  const url = `/vaccine/${hfid}/vaccinations/${vid}/continue-vaccination/`;
  return apiService(url, "POST", formData, true);
};

export const createAefi = (hfid: number, formData: Record<string, any>) => {
  const url = `/vaccine/${hfid}/aefi/`; // Changed to /aefi/
  console.log("createAefi request:", { url, formData });
  return apiService(url, "POST", formData, true);
};

export const getAefiCategories = (hfId: number) => {
  const url = `/vaccine/${hfId}/aefi/category/`;
  return apiService(url, "GET", null, true);
};

export const getAefiTypes = (hfId: number, category: string) => {
  const url = `/vaccine/${hfId}/aefi/category/types/`;
  return apiService(url, "GET", null, true, undefined, undefined, { category });
};
